import { useEffect, useRef, useState } from 'react'

export const useModalAnimation = () => {
  const modalRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
    const timer = setTimeout(() => {
      modalRef.current?.classList.add('modal--in')
    }, 10)

    return () => clearTimeout(timer)
  }, [])

  return { modalRef, isVisible }
}
